import React from "react";
import { Typography, Link } from "@mui/material";
import PropTypes from "prop-types";
import clsx from "clsx";

import { externalRoutes } from "routes";
import GooglePlay from "assets/images/about-us/google-play-badge.svg";
import AppStore from "assets/images/about-us/app-store-badge.svg";

import useStyles from "./useStyles";

const AppsPromo = ({ addSpacing = false }) => {
  const classes = useStyles();
  const url = externalRoutes.jjOneLinkApps();

  return (
    <div className={clsx({ [classes.spacing]: addSpacing })}>
      <Typography variant="large" className={classes.text} align="center">
        Download our app to stick your face in funny GIFs and videos
      </Typography>
      <div className={classes.storesContainer}>
        <Link href={url} target="_blank" rel="noreferrer">
          <img className={classes.image} src={AppStore} alt="Download on the App Store" loading="lazy" />
        </Link>
        <Link href={url} target="_blank" rel="noreferrer">
          <img className={classes.image} src={GooglePlay} alt="Get it on Google Play" loading="lazy" />
        </Link>
      </div>
    </div>
  );
};

AppsPromo.propTypes = {
  addSpacing: PropTypes.bool,
};

export default AppsPromo;
